"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HANDLED_AMAZON_ERROR_CODES = exports.AmazonErrorCode = void 0;
var AmazonErrorCode;
(function (AmazonErrorCode) {
    // Product error codes
    AmazonErrorCode["CAPACITY_EXCEEDED"] = "CAPACITY_EXCEEDED";
    AmazonErrorCode["EXCLUDED_FROM_COMMINGLING"] = "EXCLUDED_FROM_COMMINGLING";
    AmazonErrorCode["EXP_DATED_ITEM_HAS_EXISTING_STICKERLESS_MAP"] = "EXP_DATED_ITEM_HAS_EXISTING_STICKERLESS_MAP";
    AmazonErrorCode["EXTERNAL_ID_MAPS_MULTIPLE_IAIDS"] = "EXTERNAL_ID_MAPS_MULTIPLE_IAIDS";
    AmazonErrorCode["EXTERNAL_ID_MAPS_MULTIPLE_IAIDS_FOR_EXISTING_MAP"] = "EXTERNAL_ID_MAPS_MULTIPLE_IAIDS_FOR_EXISTING_MAP";
    AmazonErrorCode["FAILED_TO_REVIEW_PACKAGE_REASON"] = "FAILED_TO_REVIEW_PACKAGE_REASON";
    AmazonErrorCode["INVALID_MSKU_REMAP"] = "INVALID_MSKU_REMAP";
    AmazonErrorCode["INVALID_PRODUCTS"] = "INVALID_PRODUCTS";
    AmazonErrorCode["ITEM_BLOCKED_BY_GATING"] = "ITEM_BLOCKED_BY_GATING";
    AmazonErrorCode["ITEM_MISMATCH"] = "ITEM_MISMATCH";
    AmazonErrorCode["ITEM_STRANDED"] = "ITEM_STRANDED";
    AmazonErrorCode["ITEM_UNDER_HAZMAT_REVIEW"] = "ITEM_UNDER_HAZMAT_REVIEW";
    AmazonErrorCode["ITEM_WITH_NO_VALID_FC"] = "ITEM_WITH_NO_VALID_FC";
    AmazonErrorCode["LABEL_PREP_OWNER_INCOMPATIBILITY_ERROR"] = "LABEL_PREP_OWNER_INCOMPATIBILITY_ERROR";
    AmazonErrorCode["LTSF_RESTRICTION"] = "LTSF_RESTRICTION";
    AmazonErrorCode["MELTABLE_PRODUCT_RESTRICTION"] = "MELTABLE_PRODUCT_RESTRICTION";
    AmazonErrorCode["MISSING_ASIN"] = "MISSING_ASIN";
    AmazonErrorCode["MISSING_DIMENSIONS"] = "MISSING_DIMENSIONS";
    AmazonErrorCode["NO_EXTERNAL_IDENTIFIER_FOR_EXISTING_MAP"] = "NO_EXTERNAL_IDENTIFIER_FOR_EXISTING_MAP";
    AmazonErrorCode["NOT_IN_PRODUCT_CATALOG"] = "NOT_IN_PRODUCT_CATALOG";
    AmazonErrorCode["OVER_ASIN_GUIDANCE"] = "OVER_ASIN_GUIDANCE";
    AmazonErrorCode["QUANTITY_IS_NOT_DIVISIBLE_BY_QTY_IN_CASE"] = "QUANTITY_IS_NOT_DIVISIBLE_BY_QTY_IN_CASE";
    AmazonErrorCode["SUPPLY_CATEGORY_UNAVAILABLE"] = "SUPPLY_CATEGORY_UNAVAILABLE";
    AmazonErrorCode["UNKNOWN_SKU"] = "UNKNOWN_SKU";
    AmazonErrorCode["EXTERNAL_ID_MAPS_WRONG_IAID_FOR_EXISTING_MAP"] = "EXTERNAL_ID_MAPS_WRONG_IAID_FOR_EXISTING_MAP";
    AmazonErrorCode["HAZMAT_ITEM_INELIGIBLE"] = "HAZMAT_ITEM_INELIGIBLE";
    AmazonErrorCode["EXCEEDED_UNITS_PER_ITEM_LIMIT"] = "EXCEEDED_UNITS_PER_ITEM_LIMIT";
    AmazonErrorCode["BRAND_RETAIL_ONLY_MERCHANT"] = "BRAND_RETAIL_ONLY_MERCHANT";
    AmazonErrorCode["UNITS_PER_CASE_EXCEEDED"] = "UNITS_PER_CASE_EXCEEDED";
    AmazonErrorCode["ANDON_PULL_STRIKE_ONE"] = "ANDON_PULL_STRIKE_ONE";
    AmazonErrorCode["MULTI_OPTIONS_NOT_ALLOWED"] = "MULTI_OPTIONS_NOT_ALLOWED";
    AmazonErrorCode["DUPLICATE_FNSKU"] = "DUPLICATE_FNSKU";
    AmazonErrorCode["FIOS_NO_PATHS_TO_CUSTOMER"] = "FIOS_NO_PATHS_TO_CUSTOMER";
    // Shipment error codes
    AmazonErrorCode["AMAZON_CONTRACT_NOT_SIGNED"] = "AMAZON_CONTRACT_NOT_SIGNED";
    AmazonErrorCode["CANNOT_CONFIRM_TRANSPORT_CONTENT"] = "CANNOT_CONFIRM_TRANSPORT_CONTENT";
    AmazonErrorCode["CANNOT_ESTIMATE_TRANSPORT_CONTENT"] = "CANNOT_ESTIMATE_TRANSPORT_CONTENT";
    AmazonErrorCode["CANNOT_VOID_TRANSPORT_CONTENT"] = "CANNOT_VOID_TRANSPORT_CONTENT";
    AmazonErrorCode["CARRIER_CONTRACT_NOT_SIGNED"] = "CARRIER_CONTRACT_NOT_SIGNED";
    AmazonErrorCode["CARRIER_INVALID_FOR_MARKETPLACE"] = "CARRIER_INVALID_FOR_MARKETPLACE";
    AmazonErrorCode["ERROR_ESTIMATING"] = "ERROR_ESTIMATING";
    AmazonErrorCode["INVALID_COUNTRY_SUBDIVISION_CODE"] = "INVALID_COUNTRY_SUBDIVISION_CODE";
    AmazonErrorCode["MISSING_CARRIER_TYPE"] = "MISSING_CARRIER_TYPE";
    AmazonErrorCode["NO_PACKAGE_OR_PALLETS"] = "NO_PACKAGE_OR_PALLETS";
    AmazonErrorCode["SELLER_IS_BLOCKED_BY_CORD_MANAGAER"] = "SELLER_IS_BLOCKED_BY_CORD_MANAGAER";
    AmazonErrorCode["SELLER_IS_BLOCKED_ON_INBOUNDING_SHIPMENTS"] = "SELLER_IS_BLOCKED_ON_INBOUNDING_SHIPMENTS";
    AmazonErrorCode["TRANSPORT_CONTENT_NOT_FOUND"] = "TRANSPORT_CONTENT_NOT_FOUND";
    AmazonErrorCode["UNKNOWN_CARRIER_TYPE"] = "UNKNOWN_CARRIER_TYPE";
    AmazonErrorCode["SHIPMENT_UPDATE_NOT_ALLOWED"] = "SHIPMENT_UPDATE_NOT_ALLOWED";
    AmazonErrorCode["SHIPMENT_STATUS_CHANGE_NOT_ALLOWED"] = "SHIPMENT_STATUS_CHANGE_NOT_ALLOWED";
})(AmazonErrorCode || (exports.AmazonErrorCode = AmazonErrorCode = {}));
exports.HANDLED_AMAZON_ERROR_CODES = [
    AmazonErrorCode.CAPACITY_EXCEEDED,
    AmazonErrorCode.MISSING_DIMENSIONS,
    AmazonErrorCode.AMAZON_CONTRACT_NOT_SIGNED,
    AmazonErrorCode.CARRIER_CONTRACT_NOT_SIGNED,
    AmazonErrorCode.SELLER_IS_BLOCKED_ON_INBOUNDING_SHIPMENTS,
    AmazonErrorCode.QUANTITY_IS_NOT_DIVISIBLE_BY_QTY_IN_CASE,
    AmazonErrorCode.SELLER_IS_BLOCKED_BY_CORD_MANAGAER,
    AmazonErrorCode.SHIPMENT_UPDATE_NOT_ALLOWED,
    AmazonErrorCode.SHIPMENT_STATUS_CHANGE_NOT_ALLOWED,
    AmazonErrorCode.ITEM_WITH_NO_VALID_FC,
    AmazonErrorCode.NO_EXTERNAL_IDENTIFIER_FOR_EXISTING_MAP,
    AmazonErrorCode.ITEM_UNDER_HAZMAT_REVIEW,
    AmazonErrorCode.EXTERNAL_ID_MAPS_MULTIPLE_IAIDS,
    AmazonErrorCode.UNKNOWN_SKU,
    AmazonErrorCode.INVALID_MSKU_REMAP,
    AmazonErrorCode.ITEM_BLOCKED_BY_GATING,
    AmazonErrorCode.MISSING_ASIN,
    AmazonErrorCode.NOT_IN_PRODUCT_CATALOG,
    AmazonErrorCode.EXCLUDED_FROM_COMMINGLING,
    AmazonErrorCode.ITEM_STRANDED,
    AmazonErrorCode.LTSF_RESTRICTION,
    AmazonErrorCode.MELTABLE_PRODUCT_RESTRICTION,
    AmazonErrorCode.FAILED_TO_REVIEW_PACKAGE_REASON,
    AmazonErrorCode.EXP_DATED_ITEM_HAS_EXISTING_STICKERLESS_MAP,
    AmazonErrorCode.LABEL_PREP_OWNER_INCOMPATIBILITY_ERROR,
    AmazonErrorCode.OVER_ASIN_GUIDANCE,
    AmazonErrorCode.SUPPLY_CATEGORY_UNAVAILABLE,
    AmazonErrorCode.EXTERNAL_ID_MAPS_MULTIPLE_IAIDS_FOR_EXISTING_MAP,
    AmazonErrorCode.INVALID_PRODUCTS,
    AmazonErrorCode.HAZMAT_ITEM_INELIGIBLE,
    AmazonErrorCode.EXTERNAL_ID_MAPS_WRONG_IAID_FOR_EXISTING_MAP,
    AmazonErrorCode.EXCEEDED_UNITS_PER_ITEM_LIMIT,
    AmazonErrorCode.BRAND_RETAIL_ONLY_MERCHANT,
    AmazonErrorCode.UNITS_PER_CASE_EXCEEDED,
];
//# sourceMappingURL=AmazonErrorCode.js.map